import { render } from "./AddSystemTutorialDialog.vue?vue&type=template&id=52b3dca2&scoped=true&ts=true"
import script from "./AddSystemTutorialDialog.vue?vue&type=script&lang=ts"
export * from "./AddSystemTutorialDialog.vue?vue&type=script&lang=ts"

import "./AddSystemTutorialDialog.vue?vue&type=style&index=0&id=52b3dca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b3dca2"]])

export default __exports__